import { render, staticRenderFns } from "./StepComponent.vue?vue&type=template&id=76b212ec&scoped=true"
import script from "./StepComponent.vue?vue&type=script&lang=js"
export * from "./StepComponent.vue?vue&type=script&lang=js"
import style0 from "./StepComponent.vue?vue&type=style&index=0&id=76b212ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b212ec",
  null
  
)

export default component.exports